import * as React from "react";
import ContactView from "../views/Contact/ContactView";
import {graphql} from "gatsby";

const ContactUs: React.FC = () => {
	return (
		<div>
			<ContactView/>
		</div>
	);
};

export default ContactUs;

export const query = graphql`
	query($language: String!) {
		locales: allLocale(filter: {language: {eq: $language}}) {
			edges {
				node {
					ns
					data
					language
				}
			}
		}
	}
`;
